(ns bleene.dag.commons
  (:require
   [applied-science.js-interop :as jsi]
   [clojure.browser.dom]
   [re-frame.core :as re-frame]))


(defn get-bounding-client-rect
  ([]
   (get-bounding-client-rect {}))

  ([{:keys [x y width height]
     :or   {x 0 y 0 width 0 height 0}}]
   {:width  width,
    :height height,
    :top    y
    :left   x}))

(def tooltip-virtual-ref
  (atom (get-bounding-client-rect)))


(defn open-tooltip [event content]
  (jsi/assoc! event :cancelBubble true)
  (jsi/call-in event [:evt :preventDefault])
  (re-frame/dispatch-sync [:dag/open-tooltip false])

  (let [y (jsi/get-in event [:evt :clientY])
        x (jsi/get-in event [:evt :clientX])]
    (reset! tooltip-virtual-ref (get-bounding-client-rect {:y y :x x}))
    (re-frame/dispatch [:dag/open-tooltip true content])))


(def context-virtual-ref
  #js {:getBoundingClientRect (get-bounding-client-rect)})


(defn open-context-menu
  ([event target] (open-context-menu event target nil))
  ([event target params]
   (let [{:keys [as-menu]} params]
     (jsi/assoc! event :cancelBubble true)
     (jsi/call-in event [:evt :preventDefault])
     (re-frame/dispatch-sync [:dag/open-context-menu false])

     (let [top  (jsi/get-in event [:evt :clientY])
           left (jsi/get-in event [:evt :clientX])

           top' (if as-menu
                  (+ top 30)
                  top)

           left' (if as-menu
                   (- left 30)
                   left)]

       ;; https://github.com/radix-ui/primitives/issues/1307#issuecomment-1689754796
       ;; Hopefully a temporary hack that we'll be able to replace with
       ;; something more maintainable once radix guys relese a controlled
       ;; version of the context menu component.
       ;; TODO: replace with a controlled version of the context menu component
       (let [el (clojure.browser.dom/get-element "dag-node-dropdown-menu")]
         (jsi/call-in el [:dispatchEvent]
                      (new js/MouseEvent "contextmenu" #js {:bubbles true
                                                            :clientX left'
                                                            :clientY top'})))

       (jsi/assoc! context-virtual-ref :getBoundingClientRect (get-bounding-client-rect {:y top' :x left'}))
       (re-frame/dispatch [:dag/context-menu-target target])
       (re-frame/dispatch [:dag/open-context-menu true])))))


(defn select-node [stage dag-id id]
  (let [click-event (str "click." id)]
    (re-frame/dispatch [:dag/select-node dag-id id])

    ;; Set click handler on Stage to track outside node clicks
    ;; then unselect node and remove event handler.
    ;; Global handler becomes a mess to figure out the event context
    (jsi/call stage :on click-event
      (fn [new-event]
        (let [target (jsi/get new-event :target)
              ;; we have to find a node itself
              ;; event target could be any nested element
              node   (if (= (jsi/call target :name) "node")
                       target
                       (jsi/call target :findAncestor ".node"))]
          (when (or (nil? node)
                    (not= (jsi/call node :id) id))
            (re-frame/dispatch-sync [:dag/select-node dag-id nil])
            (jsi/call stage :off click-event)))))))
